/**
 * Filter resume bar for mobile view
 */
const FilterResume = {
  $container: document.querySelector('.js-filter-resume'),
  $model: {},
  data: [],
  wordingSearch: {},
  /**
   * Initialization
   * @return {FilterResume}
   */
  init: function (model) {
    if (this.$container) {
      this.$model = model;
      this.wordingSearch = SEARCH_SCRIPTS.WORDING_SEARCH;
      this.update();
      return this;
    }
  },
  /**
   * Update datas
   */
  update: function () {
    const rawDatas = [{
      facet: 'ACTIVITIES',
      values: this.$model.get('ACTIVITIES')
    }, {
      facet: 'PRICE',
      values: this.$model.get('PRICE')
    }, {
      facet: 'CLASSIFICATIONCOMFORT',
      values: this.$model.get('CLASSIFICATIONCOMFORT')
    }, {
      facet: 'HOUSINGCATEGORY',
      values: this.$model.get('HOUSINGCATEGORY')
    }, {
      facet: 'HOUSINGSPEC',
      values: this.$model.get('HOUSINGSPEC')
    }, {
      facet: 'NUMBEROFBEDROOMS',
      values: this.$model.get('NUMBEROFBEDROOMS')
    }, {
      facet: 'EQUIPMENT',
      values: this.$model.get('EQUIPMENT')
    }];

    // Retrieve the selection order from the model
    const selectionOrder = this.$model.get('selectionOrder');
    this.data = selectionOrder
      .map(selectionValue => {
        const isObjectSelection = typeof selectionValue === 'object';
        const selectionKey = isObjectSelection ? Object.keys(selectionValue)[0] : null;
        const matchingItem = rawDatas.find(item =>
          isObjectSelection ? item.facet === selectionKey : item.values.includes(selectionValue)
        );

        if (!matchingItem) return null;
        // Handle special processing for BUDGET
        if (isObjectSelection && SEARCH_SCRIPTS.IS_FACETTE_BUDGET_SELECTED) {
          return { facet: matchingItem.facet, key: matchingItem.values };
        }

        // Exclude Price from the object (line 45)
        if (!isObjectSelection && matchingItem.facet !== 'PRICE') {
          return { facet: matchingItem.facet, key: [selectionValue] };
        }

        return null;
      })
      .filter(Boolean); // Filter out any null entries resulting

    this.render();
  },
  /**
   * Build
   * @param item
   * @return {HTMLButtonElement}
   */
  buildItem: function (item) {
    const button = document.createElement(item.facet === 'PRICE' ? 'button' : 'label');
    const inputSelector = item.facet === 'HOUSINGSPEC' ? `facette_${item.facet.toLowerCase()}Filter_${item.key}` : `facette_${item.facet.toLowerCase()}_${item.key}`;

    button.classList.add('filter-button', 'filter-resume__item');
    button.dataset.id = item.key;
    button.dataset.facette = item.facet.toLowerCase();
    button.innerHTML = this.getFilterLabel(item);

    if (item.facet === 'PRICE') {
      button.classList.add('js-resetFilter');
    } else {
      button.setAttribute('for', inputSelector);
    }

    return button;
  },
  /**
   * get filter i18n label
   * @param {object} item
   * @param {string} item.key
   * @param {string} item.facet
   * @return {string}
   */
  getFilterLabel: function (item) {
    let label = `${item.facet}-${item.key}`;

    if (item.facet === 'PRICE') {
      const labelBudgetArr = item.key.split('_');
      const labelBudgetMin = labelBudgetArr[0];
      const labelBudgetMax = labelBudgetArr[1];
      const currencyBefore = GLOBAL_SCRIPTS.CURRENCY_BEFORE;
      const currencyAfter = GLOBAL_SCRIPTS.CURRENCY_AFTER;

      label = `${currencyBefore}${labelBudgetMin}${currencyAfter} - ${currencyBefore}${labelBudgetMax}${currencyAfter}`;
    } else {
      if (typeof haveMoreTime !== 'undefined') {
        // TODO: get correct wording from string instead of copy label content.
        label = this.wordingSearch[`facette_label_${item.facet}${item.key}`] || this.wordingSearch[`facette_label_${item.facet}`];
      } else {
        let labelSelector = `#facette_${item.facet.toLowerCase()}_${item.key} + .form-checkboxLabel`;

        switch (item.facet) {
          case 'HOUSINGSPEC':
            labelSelector = `#facette_${item.facet.toLowerCase()}Filter_${item.key} + .form-checkboxLabel`;
            break;
          case 'NUMBEROFBEDROOMS':
            label = item.key > 1 ? this.wordingSearch.facette_nb_bedrooms_label_plural : this.wordingSearch.facette_nb_bedrooms_label_singular;
            label = `${item.key} ${label}`;
            break;
        }

        const domLabel = document.querySelector(labelSelector);

        label = domLabel ? domLabel.innerText : label;
      }
    }

    return label;
  },
  /**
   * Render the select bar
   */
  render: function () {
    this.$container.innerHTML = '';
    const filteredData = this.data.filter(item => item.key !== '');
    $('.searchFilters-filter').toggleClass('has-resume', filteredData.length > 0);
    for (const item of filteredData) {
      if (item.key) {
        this.$container.appendChild(this.buildItem(item));
      }
    }
  }
};

export default FilterResume;